import { Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AddPermitPage from './pages/AddPermitPage';
import MyPermitsPage from './pages/MyPermitsPage';
import HowToGuidePage from './pages/HowToGuidePage';
import SettingsPage from './pages/settings/SettingsPage';
import ChangePasswordPage from './pages/settings/ChangePasswordPage';
import PrivateRoute from './components/PrivateRoute';
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ScrollToTop from "./components/ScrollToTop";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SignUpPage from "./pages/SignUpPage";


function App() {
  return (
    <MainLayout>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
        <Route path="/add-permit" element={<PrivateRoute><AddPermitPage /></PrivateRoute>} />
        <Route path="/my-permits" element={<PrivateRoute><MyPermitsPage /></PrivateRoute>} />
        <Route path="/how-to-guide" element={<PrivateRoute><HowToGuidePage /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
        <Route path="/settings/change-password" element={<PrivateRoute><ChangePasswordPage /></PrivateRoute>} />
        {/* <Route path="/settings/update-email" element={<PrivateRoute><UpdateEmailPage /></PrivateRoute>} /> */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/register" element={<SignUpPage />} />
      </Routes>
    </MainLayout>
  );
}

export default App;
